import { render, staticRenderFns } from "./ContainerFullscreenSuccess.vue?vue&type=template&id=472aabb9"
import script from "./ContainerFullscreenSuccess.vue?vue&type=script&lang=js"
export * from "./ContainerFullscreenSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports